import { render, staticRenderFns } from "./shengjiLessNew.vue?vue&type=template&id=09f1cfbf&scoped=true"
import script from "./shengjiLessNew.vue?vue&type=script&lang=js"
export * from "./shengjiLessNew.vue?vue&type=script&lang=js"
import style0 from "./shengjiLessNew.vue?vue&type=style&index=0&id=09f1cfbf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f1cfbf",
  null
  
)

export default component.exports